import { useTenant, useUserUid } from "hooks/settings";
import {
  LoadBasketRead,
  generatedApi,
  useGetCraneAssignedBasketQuery,
} from "src/store/api/generatedApi";
import { useAppDispatch } from "store/store";
import { refreshMS } from "../utils";

interface AssignedLoadsData {
  data: LoadBasketRead[];
  refreshBasket: (basket: LoadBasketRead) => Promise<void>;
}
export const useAssignedLoads: () => AssignedLoadsData = () => {
  const tenantName = useTenant();
  const dispatch = useAppDispatch();
  const craneUserUid = useUserUid() ?? "";

  const { currentData: assignedBasketData, refetch } =
    useGetCraneAssignedBasketQuery(
      { tenantName, craneUserUid },
      { pollingInterval: refreshMS }
    );
  const data = assignedBasketData?.loads ?? [];
  return {
    data,
    refreshBasket: async (basket) => {
      await refetch();
      dispatch(
        generatedApi.util.updateQueryData(
          "getCraneAssignedBasket",
          { tenantName, craneUserUid },
          (draft) => {
            draft.loads = draft.loads.flatMap((assigned) =>
              assigned.load_basket_id !== basket.load_basket_id
                ? [assigned]
                : basket.status === "filled"
                  ? []
                  : [basket]
            );
          }
        )
      );
    },
  };
};
